import EverymatrixHelper from './everymatrix';

export default class Helper extends EverymatrixHelper
{
    static init()
    {
        super.init();
    }
}
